/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import Header from '../../View/Header';
import LoadingIndicator from '../../View/LoadingIndicator';
import api from '../../utils/api';
import { GET_PARENT_CONTACT, SUBMIT_PARENT_CONTACT } from '../../utils/apiEndPoint';
import history from '../../utils/history';
import { afterLogOut } from '../../utils/logout';
import { maskedEmail, maskedMobileNo } from '../../utils/maskedString';
import { errMsg } from '../../utils/messages';
import ContactList from '../../View/ContactList';

const ParentContact = () => {
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const loggedInUser = JSON.parse(sessionStorage.getItem('login_details'));

  const [contactDetails, setContactDetails] = useState([]);
  const [selectedParentId, setSelectedParentId] = useState('');
  const [selectedParentObj, setSelectedParentObj] = useState({});
  const [notificationType, setNotificationType] = useState('');
  const [isNextActive, setIsNextActive] = useState(false);

  const [errorParentContact, setErrorParentContact] = useState(null);
  const [errorParentName, setErrorParentName] = useState(null);
  const [errorGetData, setErrorGetData] = useState('');
  const [errorSubmitData, setErrorSubmitData] = useState(false);
  const [errorMsgAtSubmit, setErrorMsgAtSubmit] = useState('');
  // 113223 for local testing

  useEffect(() => {
    api.get(`${GET_PARENT_CONTACT}/${loggedInUser.studentId}`)
      .then((res) => {
        if (res.status === 200) {
          const array = res.data.map((data) => {
            data.selected = false;
            return data;
          });
          setErrorGetData('');
          setContactDetails(array);
        } else if (res.status === 404) {
          setErrorGetData(res.msg);
        } else {
          setErrorGetData(errMsg);
        }
        setLoading(false);
      })
      .catch(() => {
        setErrorGetData(errMsg);
        setLoading(false);
      });
  }, [loggedInUser.studentId]);

  useEffect(() => {
    let obj = {};
    contactDetails.map((data) => {
      if (data.contact_id === selectedParentId && data.selected === true) {
        obj = data;
      }
      return null;
    });
    setSelectedParentObj(obj);
  }, [selectedParentId]);

  const onChangeParentName = (e) => {
    setErrorParentName(false);
    const array = Array.from(contactDetails);
    const updatedArray = array.map((data) => {
      if (data.contact_id === e.target.value) {
        data.selected = true;
      } else {
        data.selected = false;
      }
      return data;
    });
    setContactDetails(updatedArray);
    setSelectedParentId(e.target.value);
  };

  const onChangeParentContact = (e, type) => {
    setErrorParentContact(false);
    setErrorSubmitData(false);
    if (e.target.checked) {
      setSelectedParentId(e.target.value);
      setNotificationType(type);
    }
  };

  const onNext = () => {
    if (selectedParentId) {
      setErrorParentName(null);
      setIsNextActive(true);
    } else {
      setErrorParentName('Please select parent name.');
    }
  };

  const onBack = () => {
    setErrorParentContact(null);
    setNotificationType('');
    setIsNextActive(false);
  };

  const onContactSubmit = () => {
    if (notificationType) {
      setErrorParentContact(null);
      setSubmitLoading(true);
      setErrorSubmitData(false);
      const selectedContact = {
        contact_id: selectedParentId,
        form_type: 'AbsenceClearnce',
        student_id: loggedInUser.studentId,
        notification_type: notificationType,
      };

      api.post(SUBMIT_PARENT_CONTACT, selectedContact)
        .then((res) => {
          if (res.status === 200) {
            history.push({
              pathname: '/thankyou',
              state: {
                msg: 'Your login details have been sent to the selected Phone or Email',
                btnText: 'Go to Home',
                path: '/login',
                logout: false,
              },
            });
          } else {
            setErrorSubmitData(true);
            setErrorMsgAtSubmit(res.msg);
          }
          setSubmitLoading(false);
        })
        .catch(() => {
          setErrorSubmitData(true);
          setSubmitLoading(false);
          setErrorMsgAtSubmit(errMsg);
        });
    } else {
      setErrorParentContact('Please select any contact detail of parent.');
    }
  };

  const parentContactUI = () => {
    if (errorGetData) {
      return (
        <p style={{ color: 'red', fontSize: 14 }} className="text-center">
          {errorGetData}
        </p>
      );
    }
    if (contactDetails.length === 0 && !errorGetData) {
      return <p className="text-center">No Record Found.</p>;
    }
    if (contactDetails.length !== 0 && !errorGetData && !isNextActive) {
      return (
        <>
          <h3>
            Contact Details
            <span style={{ color: 'red', fontSize: 12 }}>*</span>
          </h3>
          <h6>
            Please select parent name to receive your automated login link.
          </h6>
          <ul>
            {contactDetails.map((contact) => (
              <ContactList
                key={contact.name}
                id={contact.contact_id}
                name="name"
                checked={contact.selected}
                labelText={`${contact.contact_name} (${contact.relation_description})`}
                onChange={onChangeParentName}
              />
            ))}
          </ul>
          {errorParentName
          && <span style={{ color: 'red', fontSize: 12 }}>{errorParentName}</span>}
          <button
            id="submit_contact"
            type="submit"
            className="submit-parent-contact"
            onClick={onNext}
            disabled={submitLoading}
          >
            Next
          </button>
        </>
      );
    }
    if (contactDetails.length !== 0 && !errorGetData && isNextActive) {
      return (
        <>
          <button
            id="submit_contact"
            type="submit"
            className="back-btn-name"
            onClick={onBack}
            disabled={submitLoading}
          >
            <span className="icon-fa">
              <FontAwesomeIcon icon={faChevronLeft} />
              {' '}
              Back
            </span>
          </button>
          <h3 className="contact-name-back">
            {`${selectedParentObj.contact_name} (${selectedParentObj.relation_description})`}
          </h3>
          <h6>
            Please select the phone or email address where you would like to
            receive your automated login link.
            <span style={{ color: 'red', fontSize: 12 }}>*</span>
          </h6>
          <ul>
            {selectedParentObj.telephone && (
            <ContactList
              key={selectedParentObj.name}
              id={selectedParentObj.contact_id}
              name="contacts"
              labelText={maskedMobileNo(selectedParentObj.telephone)}
              onChange={(e) => onChangeParentContact(e, 'sms')}
            />
            )}
            {selectedParentObj.email && (
            <ContactList
              key={selectedParentObj.name}
              id={selectedParentObj.contact_id}
              name="contacts"
              labelText={maskedEmail(selectedParentObj.email)}
              onChange={(e) => onChangeParentContact(e, 'email')}
            />
            )}
            {(!selectedParentObj.telephone && !selectedParentObj.email) && (
              <p>Parent have no phone or email.</p>
            )}
          </ul>
          {errorParentContact
          && <span style={{ color: 'red', fontSize: 12 }}>{errorParentContact}</span>}
          <button
            id="submit_contact"
            type="submit"
            className="submit-parent-contact"
            onClick={onContactSubmit}
            disabled={submitLoading}
          >
            {submitLoading ? <LoadingIndicator className="login-loader" /> : 'Submit'}
          </button>
          {errorSubmitData
          && <p className="login-error">{errorMsgAtSubmit}</p>}
        </>
      );
    }
    return null;
  };

  return (
    <>
      <Header />
      <section className="cardindex parent-contact-list">
        {loading ? <LoadingIndicator /> : (
          <div className="column mac-ul-box">
            {parentContactUI()}
            <Link className="other_forms" onClick={afterLogOut}>Log out</Link>
          </div>
        )}
      </section>
    </>
  );
};

export default ParentContact;
